import { BaseEntity } from ".";
import { IGet_characters_character_id_wallet_journal_200_ok } from "../service/esiclient";
import { getCachedCharacterEntity } from "./CharacterEntityCache";
import moment from "moment";

export class CharacterWalletJournalEntity extends BaseEntity {
  constructor(id: number, props: any, character_id: number) {
    super(id, props);
    this._dataTypeName = "Character Journal";
    this._character_id = character_id;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    //This dataset is very basic
    //it has a journal reference but unsure if linking it is possible, especially if the transactions haven't been called.
    //since there is no single id call from esi to utilize
    const props: Partial<IGet_characters_character_id_wallet_journal_200_ok> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      const characterEntity = await getCachedCharacterEntity(this._character_id);
      if (characterEntity !== null) {
        entity.properties["owner"] = await characterEntity.toJson();
      }
      if (props.date) {
        const date = moment(props.date);
        entity.properties["date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: date.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      const numberOptions = { minimumFractionDigits: 2 };
      const priceVar = props.amount?.toLocaleString("en-GB", numberOptions);
      // The display for now is "amount ISK (description)"", not a lot of informative strings in this property
      entity.text = priceVar + " ISK (" + props.description?.toString() + ")";
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
    }
    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
